import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import SubDocument from '../SubDocument';
import Hospital from '../Hospital';
import AddDocument from '../AddDocument';
import HandleSubmission from '../HandleSubmission'
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';
import { ErrorMessage } from 'formik';
import DatePicker from 'react-datepicker'
import { types } from '../configData'
import {
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Card,
  CardBody
} from "reactstrap";



// import SubDocument from './SubDocument';


const AddpregnancyRecord = (props) => {

  // if(props.status.success == true && props.values.addmore == true) {
  //   console.log(props.status)
  //   return <Redirect to={{
  //     pathname: "/addpregnancyrecord",
  //     state: {
  //       type: props.values.type,
  //       stage: props.values.stage,
  //       documentType: props.documentType
  //     }
  //   }} />
  // }

  // if(props.status.redirect == true && props.isSubmitting == false) {
  //   console.log(props.status)
  //   return <Redirect to="/pregnancyrecord" />
  // }

    return (
      <Card>
        {console.log(props.errors)}
        <CardBody>
              <Form onSubmit={props.handleSubmit}>
                <Row>
                  <Col xs="12">
                    <Label>
                      Type of Pregnancy: {types[props.values.type]}
                    </Label>
                </Col>
                </Row>
                <Row>
                  {props.values.type === 1 ? 
                    <PreviousPregnancy
                      concieveOptions={props.status.concieveMethods}
                      concieve={props.values.concieve}
                      setFieldValue={props.setFieldValue}
                      errors={props.errors}
                      touched={props.touched}
                    /> :
                    props.values.type === 2 ?
                    <CurrentPregnancy 
                      stage={props.values.stage} 
                      lmd={props.values.lmd}
                      handleChange={props.handleChange}
                      setFieldValue={props.setFieldValue}
                      errors={props.errors}
                      touched={props.touched}
                    /> : 
                    <SubDocument
                      subDocuments={props.status.subDocuments} 
                      subDocumentType={props.values.subDocumentType}
                      setFieldValue={props.setFieldValue}
                      errors={props.errors}
                      touched={props.touched}
                    />
                  }
                </Row>
                <Hospital
                  name={props.status.name} 
                  values={props.values}
                  handleChange={props.handleChange}
                  errors={props.errors}
                  touched={props.touched}
                />
                <React.Fragment>
                  <AddDocument 
                    type={props.values.type}
                    category={props.values.category}
                    documentType={props.status.documentType}
                    documentsOption={props.status.documentsOption}
                    title={props.values.document.title} 
                    description={props.values.document.description}
                    appointment={props.values.document.appointment}
                    fileInputKey={props.submitCount}
                    handleChange={props.handleChange}
                    setFieldValue={props.setFieldValue}
                    files={props.values.files}
                    uploadedFiles={props.status.files}
                    formType={props.formType}
                    deleteImage={props.deleteImage}
                    errors={props.errors}
                    touched={props.touched}
                  />
                </React.Fragment>
                <div className="text-center">
                  <HandleSubmission 
                    setFieldValue={props.setFieldValue}
                    submitForm={props.submitForm}
                    formType={props.formType}
                  />
                </div>

                {/* <div className="text-center">                
                  <Button className="btn" onClick={(e) => { 
                    props.setFieldValue("redirect", true)
                    props.handleSubmit();
                  }}>Save
                  </Button>
                  <Button className="btn" type="submit">Save and Add new record</Button>
                </div> */}
              </Form>
        </CardBody>
      </Card>
    )
}


const CurrentPregnancy = (props) => (
  <React.Fragment>
    <Col xs="12" md="4">
      <Label>
        Current Pregnancy Stage: {props.stage['label']}
      </Label>
    </Col>
    <Col xs="12" md="4">
      <Label for="lastLMP">
        Enter Date of Last LMP(Last Menstrual Period)
      </Label>
      <DatePicker 
        selected={props.lmd}
        onChange={date => props.setFieldValue("lmd", date)}
        maxDate={new Date()}
      />
      <ErrorMessage name="lmd">{msg => <div id="feedback" className="text-danger">{msg}</div>}</ErrorMessage>
    </Col>
  </React.Fragment>
)

const PreviousPregnancy = (props) => (
  <Col xs="12" md="4">
    <FormGroup>
      <Label>Concieving Method</Label>
      <Select name="concieve" 
        options={props.concieveOptions}
        value={props.concieve}
        onChange={(selectedOption) => props.setFieldValue('concieve', selectedOption)}        
      />
      <ErrorMessage name="concieve">{msg => <div id="feedback" className="text-danger">{msg.value}</div>}</ErrorMessage>
    </FormGroup>
  </Col>
)

export default AddpregnancyRecord;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyRecord/AddpregnancyRecord.js